/** A distinct immutable URL namespace for the iOS loader's 512 MiB address-space cap. */
export const IOS_ORT_DIRECTORY = "memory512-v1";
export const IOS_ORT_MAX_PAGES = 8192;

/**
 * ORT 1.27 creates a shared memory with a 4 GiB maximum even with numThreads=1.
 * WebKit may reject that reservation before loading any model. The public env API
 * exposes no memory limit, and this loader ignores Emscripten's wasmMemory override.
 * Adjust only the generated loader's allocation and growth ceiling; the matching
 * WASM binary, models and installed package remain unchanged. Fail on upstream drift.
 */
export function iosOrtLoader(source: string, filename: string): string {
  const allocation = "new WebAssembly.Memory({initial:256,maximum:65536,shared:!0})";
  if (source.split(allocation).length !== 2 || source.split("4294901760").length !== 4)
    throw new Error(`Unrecognized ORT memory layout in ${filename}; review the iOS memory cap`);
  return source
    .replace(
      allocation,
      `new WebAssembly.Memory({initial:256,maximum:${IOS_ORT_MAX_PAGES},shared:!0})`,
    )
    .replaceAll("4294901760", String(IOS_ORT_MAX_PAGES * 65536));
}
